// extracted by mini-css-extract-plugin
export default {"header":"RankingMain_header__gU9t9","nav":"RankingMain_nav__U4j0f","active":"RankingMain_active__dub8A","ranking-list":"RankingMain_ranking-list__R0aao"};